module.exports = __webpack_public_path__ + "fontawesome-webfont.a130857edacbb0559ef6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = 1378
// module chunks = 7